import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import '../css/Header.css';
import {handleLogout} from "../utils/logout";
import {checkSessionUser} from "../utils/auth";

function Header() {
    const navigate = useNavigate();
    const [profileBox, setProfileBox] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [id, setId] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        checkSessionUser((data) => {
            console.log("서버에서 받은 유저 정보:", data); // 데이터 구조 확인용
            setUserInfo(data);
        }, setId, setIsLoggedIn);
    }, []);

    const isLogin = !!userInfo?.username;
    const profileToggleBox = () => setProfileBox(!profileBox);

    const AdminRoute = ({ children, userInfo }) => {
        if (!userInfo || !userInfo.admin) {
            alert("관리자 권한이 필요합니다.");
        }
        return children;
    };

    return (
        <header className="Header-container">
            <div className="Header-left">
                <div className="Header-button-container">
                    <img src="/sn.png" alt="타이틀 이미지" style={{ width: '120px', height: '120px', marginTop: '-10px'}} />
                </div>
                <div className="Header-button-container" style={{marginLeft: '20px', marginRight: '20px'}}>
                    <button onClick={() => navigate("/")}
                            style={{
                                // fontFamily: '"Noto Sans", Arial, sans-serif',
                                fontSize: '32px'
                            }}>NEWSNAKE
                    </button>
                </div>

                <div className="Header-button-container">
                    {isLogin ? (
                        <button className="Header-text" onClick={() => navigate("/searchhistory")}>
                            History
                        </button>
                    ) : (
                        <p
                            className="Header-text"
                            onClick={() => alert("로그인 시 사용 가능한 기능입니다.")}
                            style={{cursor: 'pointer'}}
                        >
                            History
                        </p>
                    )}
                </div>
                <div className="Header-button-container"
                     style={{ marginLeft : '-30px' }}>

                    {isLogin ? (
                        <button  className="Header-text" onClick={() => navigate("/Chat")}>Chat
                        </button>
                    ) : (
                        <p
                            className="Header-text"
                            onClick={() => alert("로그인 시 사용 가능한 기능입니다.")}
                            style={{cursor: 'pointer'}}
                        >
                            Chat
                        </p>
                    )}
                </div>

                <div className="Header-button-container"
                     style={{ marginLeft : '-30px' }}>
                    <button  className="Header-text" onClick={() => navigate("/info/model")}>About
                    </button>
                </div>

                <div className="Header-button-container" style={{ marginLeft : '-30px' }}>
                    {/* userInfo 내부의 isAdmin이 true일 때만 Admin 버튼을 보여줌 */}
                    {isLogin && userInfo.isAdmin && (
                        <button className="Header-text" onClick={() => navigate("/admin")}>
                            Admin
                        </button>
                    )}
                </div>

            </div>

            <div className="Header-right">
                <div className="Header-button-container"
                     style={{ backgroundColor: '#999999', border: '2px solid transparent', padding: '5px 10px', borderRadius: '5px' }}>
                    {isLogin ? (
                        <button onClick={() => navigate("/mypage")}>내정보</button>
                    ) : (
                        <button onClick={() => navigate("/login")}>로그인</button>
                    )}
                </div>
                <div className="Header-button-container"
                    style={{ backgroundColor: '#999999', border: '2px solid transparent', padding: '5px 10px', borderRadius: '5px', marginLeft: '5px' }}>

                    {isLogin ? (
                        <button onClick={() => handleLogout(navigate, setId, setProfileBox)}>로그아웃</button>
                    ) : (
                        <button onClick={() => navigate("/signup")}>회원가입</button>
                    )}
                </div>
            </div>
        </header>
    );
}

export default Header;
